import React from 'react';
import PropTypes from 'prop-types';

const ProductBadge = ({ name, image, external_url }) => {
  const hasExternalUrl = external_url && external_url.length > 0;

  if (hasExternalUrl) {
    return (
      <a href={external_url} target="_blank" rel="noreferrer" className="product-detail__img--product-badge-link">
        <img
          src={image.thumb}
          alt={name}
          title={name}
          className="product-detail__img"
        />
      </a>
    );
  }

  return (
    <img
      src={image.thumb}
      alt={name}
      title={name}
      className="product-detail__img product-detail__img--product-badge-nolink"
    />
  );
};

ProductBadge.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.shape({
    thumb: PropTypes.string.isRequired,
    default: PropTypes.string,
  }).isRequired,
  external_url: PropTypes.string,
};

ProductBadge.defaultProps = {
  external_url: null,
};

export default ProductBadge;
